import { ViewModel,View, ObservableArray } from "binder"
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { CallServerViewModel } from "../../executablePart/callServer/callServer-viewModel";
import { CreateInstanceViewModel } from "../../executablePart/createInstance/createInstance-viewModel";
import { CreatePaginationInfoViewModel } from "../../executablePart/createPaginationInfo/createPaginationInfo-viewModel";
import { IExecutablePart } from "../../executablePart/executablePart";
import { JsCodeViewModel } from "../../executablePart/jsCode/jsCode-viewModel";
import { ShowPopupViewModel } from "../../executablePart/showPopup/showPopup-viewModel";
import  { PartTypeSelectorView } from "./partTypeSelector-view"

export class PartTypeSelectorViewModel extends ViewModel implements IPopup{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.types = ObservableArray.create<type>();
        this.types.update(...[
            new type(this,"JsCode",x=>new JsCodeViewModel(x)),
            new type(this,"CreateInstance",x=>new CreateInstanceViewModel(x)),
            new type(this,"CallServer",x=>new CallServerViewModel(x)),
            new type(this,"ShowPopup",x=>new ShowPopupViewModel(x)),
            new type(this,"CreatePaginationInfo",x=>new CreatePaginationInfoViewModel(x)),
        ])

    }
    closePopup(result?: any) {
    }
    GetDefaultView(): View <ViewModel> {
        return new PartTypeSelectorView();
    }
    public getTypeId(): string {
        return "VM-EA61B53F-8BD7-44F4-8F3A-D0D30645845C"
    }
    public set types(v: ObservableArray<type>) { this._types = v; } public get types(): ObservableArray<type> { return this._types;} private _types: ObservableArray<type>;
    public set selectedType(v: type) { this._selectedType = v; } public get selectedType(): type { return this._selectedType;} private _selectedType: type;
    
    confirm(){
        this.closePopup(this.selectedType);
    }
    back(){
        this.closePopup();
    }
}


export class type extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel,name:string,factory:(parent)=>IExecutablePart) {
        super(parent);
        this.name = name;
        this.factory = factory;
    }
    
    public set name(v: string) { this._name = v; } public get name(): string { return this._name;} private _name: string;
    public factory : (parent)=>IExecutablePart;
}